module.exports = __webpack_public_path__ + "static/img/options-exchange.1769678785359.png";